// extracted by css-extract-rspack-plugin
export default {"IconWrapper":"JNVMB","DismissIconButtonWrapper":"l44nO","Body":"Gie5_"};